import styled from 'styled-components';

export const TextWrapper = styled.div`
  color: ${({ theme }) => theme.danger_500};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 335px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
